/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Endedtroughperson2Inputs */

const de__field_endedtroughperson2 = /** @type {(inputs: _Field_Endedtroughperson2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beendet durch`)
};

/**

* @param {_Field_Endedtroughperson2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_endedtroughperson2 = /** @type {((inputs?: _Field_Endedtroughperson2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Endedtroughperson2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_endedtroughperson2(inputs)
});
export { _field_endedtroughperson2 as "_field_endedTroughPerson" }